<div class="container-fluid">
  <h5 class="section-title mb-3 mt-1">History Log</h5>
  <mat-tab-group animationDuration="0ms" class="main-tab-group">
    <mat-tab label="Approvals">
      <div class="approvals-tab-container">
        <div class="header-and-controls">
          <h6 *ngIf="showAll" class="mt-2">
            Showing All Activity
            <span class="small ml-3" *ngIf="!signatures?.length"
              >No Activity Yet!</span
            >
          </h6>
          <h6 *ngIf="!showAll" class="mt-2">
            Showing Only Approvals
            <span class="small ml-3" *ngIf="!signatures?.length"
              >No Approvals Found!</span
            >
          </h6>
          <div>
            <mat-slide-toggle
              [(ngModel)]="showLatestFirst"
              (change)="refreshSignatures()"
              class="mr-3"
              >Show Latest First</mat-slide-toggle
            >
            <mat-slide-toggle
              [(ngModel)]="showAll"
              (change)="refreshSignatures()"
              class="mr-3"
              >Show All Activity</mat-slide-toggle
            >
            <mat-slide-toggle [(ngModel)]="showBoxes"
              >Show Signature Boxes</mat-slide-toggle
            >
          </div>
        </div>

        <div *ngIf="showBoxes" class="d-flex flex-wrap gap-2 mt-5">
          <div class="log-signature" *ngFor="let signature of signatures">
            <log-signature [signature]="signature"></log-signature>
          </div>
        </div>

        <div class="container-fluid mt-5" *ngIf="!showBoxes">
          <table>
            <ng-container *ngFor="let signature of signatures; let i = index">
              <!-- Main row -->
              <tr
                [ngClass]="{'border-bottom': !showLatestFirst && signature.status != signatures?.[i -1]?.status && !signature.reason,
                  'border-top': showLatestFirst && signature.status != signatures?.[i +1]?.status && !signature.reason
                }"
              >
                <td class="px-1">
                  <mat-icon
                    [ngClass]="
                      !showLatestFirst && i > 0 ? signatures?.[i - 1]?.statusClass : 
                      showLatestFirst ? signatures?.[i + 1]?.statusClass ?? signature.statusClass : 
                      signature.statusClass"
                  >
                    bookmark
                  </mat-icon>
                </td>

                <td>
                  <span class="date small">
                    {{ signature.signedOn | date : "medium" }}
                  </span>
                </td>

                <td>
                  <span>
                    <b
                      [ngClass]="signature.nameClass"
                      [innerHTML]="signature.name"
                    ></b>
                    <span
                      *ngIf="signature.isMinorAmendment"
                      class="minor-amendment-indicator"
                      title="Minor Amendment"
                      >Minor</span
                    >
                    by <b>{{ signature.signedBy }}</b>
                  </span>
                </td>

                <td>
                  <div class="status" *ngIf="signature.showStatus">
                    <mat-icon [ngClass]="signature.statusClass"
                      >next_plan</mat-icon
                    >
                    <span
                      class="chip"
                      [ngClass]="signature.statusClass + '-bg'"
                    >
                      {{ signature.status }}
                    </span>
                  </div>
                </td>
              </tr>

              <!-- Extra row: icon + reason together -->
              <tr
                *ngIf="signature.reason && signature.reason !== ''"
                class="border-bottom"
              >
                <!-- empty cells to align columns -->
                <td colspan="2"></td>

                <!-- icon + reason together in last column -->
                <td colspan="2" class="d-flex">
                  <mat-icon color="accent" class="mr-2">comment</mat-icon>
                  <span>
                    {{ signature.reason }}
                  </span>
                </td>
              </tr>
            </ng-container>
          </table>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Amendments" *ngIf="logForm.updates?.length">
      <mat-tab-group animationDuration="0ms" class="updates-tab-group">
        <!-- Original Form -->
        <mat-tab label="Original Form">
          <div class="amendments-tab-container">
            <div class="original-wrapper" #original>
              <form-history-forms
                [type]="formType"
                [originalBody]="originalBody"
                [form]="form"
              ></form-history-forms>
            </div>
          </div>
        </mat-tab>

        <!-- Amendments -->
        <mat-tab *ngFor="let update of logForm.updates; let i">
          <ng-template mat-tab-label>
            <div class="d-flex flex-column">
              <span
                ><span [innerHTML]="update.header"></span
                ><span
                  *ngIf="update.isMinorAmendment"
                  class="minor-amendment-indicator"
                  title="Minor Amendment"
                  >Minor</span
                ></span
              >
              <span
                [innerHTML]="update?.amendmentDate | date : 'medium'"
                class="date small"
              ></span>
            </div>
          </ng-template>
          <div class="amendments-tab-container">
            <div class="amendment-wrapper">
              <form-history-forms
                *ngIf="update.currentBody"
                [type]="formType"
                [update]="update"
                [form]="form"
              ></form-history-forms>
              <form-history-signatures
                [update]="update"
              ></form-history-signatures>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </mat-tab>
  </mat-tab-group>
</div>
